"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Link = (props) => {
    const { children, disabled = false, sx } = props, restProps = __rest(props, ["children", "disabled", "sx"]);
    const linkStyles = Object.assign(Object.assign({ alignItems: "center", color: disabled ? "text-disabled" : "text-link", fontSize: "inherit", fontWeight: "inherit", gap: 2, textDecoration: "underline", textDecorationColor: "transparent", transition: "transition-color-medium" }, (disabled
        ? {}
        : {
            "&:focus-visible": {
                borderColor: "link01",
                borderRadius: "medium",
                borderStyle: "solid",
                color: "cta02Text",
                paddingX: 1,
                paddingY: 0
            },
            "&:hover": {
                color: "text-link-hover",
                textDecorationColor: "currentColor"
            },
            "&:active": {
                color: "text-link-click",
                textDecorationColor: "currentColor"
            }
        })), sx);
    return (react_1.default.createElement(foundations_1.Target, Object.assign({}, restProps, { sx: Object.assign({}, linkStyles), disabled: disabled }), children));
};
exports.Link = Link;
//# sourceMappingURL=Link.js.map